import Form from "../../Reusable/Form/Form.js";
import apiRequest from "../../../utils/ApiRequest/apiRequest.js";
import { useUser } from "../../../contexts/userContext/userContext.js";
import { useContent } from "../../../contexts/contentContext/contentContext.js";
import { useModal } from "../../../contexts/modalContext/modalContext.js";
import { ReportFields } from "./ReportFields.js";

import "./Report.scss";

const ReportForm = () => {
  const { closeModal } = useModal();
  const { getUserData } = useUser();
  const { getLanguage, getTextByKey } = useContent();
  const reportItem = async (body) => {
    const userData = getUserData();
    const params = {
      ContactSender: userData
        ? userData.UserFirstName + " " + userData.UserLastName
        : "",
      ContactEmail: body.ReportFormEmail,
      ContactPhone: userData ? userData.UserPhone : "",
      ContactTitle: "report",
      ContactMessage: body.ReportFormMessage,
      ContactPage: window.location.href,
      ContactUserStatus: userData
        ? userData.IsSubscribed
          ? "subscribed"
          : "registered"
        : "",
      ContactUserId: userData.UserId || null,
      ContactCulture: getLanguage(),
      RecaptchaResponse: body.recaptchaResponse,
      V3Recaptcha: true,
      // captchaServiceName: "cloudflare",
    };
    const response = await apiRequest(
      "ContactMessages",
      "CreateContactMessage",
      params,
      "POST"
    );
    if (response.status === "success") {
      closeModal();
      return {
        status: response.status,
        callBack: closeModal,
      };
    }

    return response;
  };

  return (
    <div className="report-modal">
      <div className="report-form-top-section">
        <div className="report-form-top-section-header">
          {getTextByKey("report-form-title")}
        </div>
        <div className="report-form-top-section-body">
          {getTextByKey("report-form-description")}
        </div>
      </div>
      <div className="lower-section">
        <Form
          fieldsProps={{ label: "hidden" }}
          fields={ReportFields}
          onCancel={closeModal}
          cancelProps={{
            title: getTextByKey("cancel"),
            className: "blank-button",
          }}
          defaultValuesObj={{ ReportFormEmail: getUserData()?.UserName }}
          onSubmit={reportItem}
          submitProps={{ title: getTextByKey("send") }}
          // captchaProvider="cloudflare"
          // cloudflareActionName="createContactMessage"
        />
      </div>
    </div>
  );
};

export default ReportForm;
